import React, { useRef, useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useReactToPrint } from 'react-to-print'
import { FaTimesCircle, } from 'react-icons/fa'
import { useStateContext } from '../../../state/context'
import { setLabInvoice } from '../../../state/actions/actions'
import { setLabCategoryTest } from '../../../state/actions/actions'
import { createALaboratoryCategoryTest, updateALaboratoryCategoryTest } from '../../../state/actions/laboratorist.actions'
import { toast } from 'react-toastify'


const LaboratoryAddCategoryModal = () => {
    const { modals, setModals } = useStateContext()
    const { all_lab_category_test, all_lab_investigation_type, all_lab_sample_test } = useSelector((state) => state.laboratorist)
    const [formData, setFormData] = useState({
        title: '',
        id: '',
        investigation_type: ''
    })
    const { set_laboratory_category_test } = useSelector((state) => state.root)
    const handleChange = (e, name) => {
        setFormData((prevState) => ({ ...prevState, [name]: e.target.value }))
    }
    const handleSubmit = (e) => {
        e.preventDefault()
        console.log(formData)
        
        if (!formData.title) return toast.warning('Title field is required!')
        // if (!formData.last_name) return toast.warning('Last Name is required!')
        if (modals.showLaboratoryAddCategoryModal) {
            dispatch(createALaboratoryCategoryTest(({ formData, toast, setModals: setModals, modals: modals })))
        }
        if (modals.showLaboratoryUpdateCategoryModal) {
            dispatch(updateALaboratoryCategoryTest({ formData, toast, setModals: setModals, modals: modals }))
        }

    }

    useEffect(() => {
        setFormData({ ...formData, title: set_laboratory_category_test?.cat_name, id: set_laboratory_category_test?.cat_id })

    }, [set_laboratory_category_test])

    // showLaboratoryDeleteCategoryModal
    const dispatch = useDispatch()
    return (
        <div className="absolute grid h-screen w-full z-20 bg-[#11111180] place-items-center">
            <div className="bg-white w-[614px] rounded px-[30px] py-[20px]">
                <div className="flex flex-col space-y-5">
                    <div className="flex justify-between items-center">
                        {modals.showLaboratoryAddCategoryModal && (
                            <>
                                <h4 className='text-dark-green text-[20px] font-bold'>Add Investigation Category</h4>
                                <FaTimesCircle
                                    className='text-dark-yellow cursor-pointer'
                                    onClick={() => {
                                        const data = null

                                        setModals({ ...modals, showLaboratoryAddCategoryModal: !modals.showLaboratoryAddCategoryModal })
                                    }}
                                    size={20}
                                />
                            </>
                        )}
                        {modals.showLaboratoryUpdateCategoryModal && (
                            <>
                                <h4 className='text-dark-green text-[20px] font-bold'>Update Investigation Category</h4>
                                <FaTimesCircle
                                    className='text-dark-yellow cursor-pointer'
                                    onClick={() => {
                                        const data = null
                                        dispatch(setLabCategoryTest({ data }))
                                        setModals({ ...modals, showLaboratoryUpdateCategoryModal: !modals.showLaboratoryUpdateCategoryModal })
                                    }}
                                    size={20}
                                />
                            </>
                        )}

                    </div>

                    <form
                        onSubmit={handleSubmit}
                    >


                        <div>
                            {modals.showLaboratoryAddCategoryModal && (
                                <>
                                    {/* <select name="investigation_type" placeholder='Type' id="" className='border rounded mt-2 pl-2 w-full h-[40px] focus:outline-none focus:ring-blue-500 '
                                        onChange={(e) =>
                                            handleChange(e, e.target.name)
                                        }
                                    >
                                        <option value={formData.investigation_category}>Select Investigation Type</option>
                                        {all_lab_investigation_type?.map((type, index) => (
                                            <option value={type.pkid}>{type.type_title}</option>
                                        ))}

                                    </select> */}

                                    <input
                                        type="title"
                                        name="title"
                                        placeholder="Title"

                                        className="border rounded w-full h-5 px-4 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-blue-500 focus:ring-blue 5ounded"
                                        onChange={(e) => handleChange(e, e.target.name)}
                                    />
                                </>

                            )}
                            {modals.showLaboratoryUpdateCategoryModal && (
                                <input
                                    type="title"
                                    name="title"
                                    value={formData.title}
                                    placeholder="Title"

                                    className="border rounded w-full h-5 px-4 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-blue-500 focus:ring-blue 5ounded"
                                    onChange={(e) => handleChange(e, e.target.name)}
                                />
                            )}

                        </div>

                        {modals.showLaboratoryAddCategoryModal && (
                            <div className='mt-4 '>
                                <button
                                    type='submit'
                                    className="inline-block w-[175px] px-6 py-2.5 bg-dark-green text-white font-medium text-xs leading-tight rounded shadow-md hover:scale-90 transition duration-500 ease"
                                >Add</button>
                            </div>
                        )}
                        {modals.showLaboratoryUpdateCategoryModal && (
                            <div className='mt-4 '>
                                <button
                                    type='submit'
                                    className="inline-block w-[175px] px-6 py-2.5 bg-dark-green text-white font-medium text-xs leading-tight rounded shadow-md hover:scale-90 transition duration-500 ease"
                                >Update</button>
                            </div>
                        )}

                    </form>
                </div>


            </div>
        </div>
    )
}

export default LaboratoryAddCategoryModal